export const parametrizeString = (input: string): string => {
  const lowercased = input.toLowerCase().trim()

  const withoutSpecialChars = lowercased.replace(/[^\w\s]/g, '')

  const parametrized = withoutSpecialChars.replace(/\s+/g, '-')

  return parametrized
}
